import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from 'app/common.module';
import { ClickOutsideModule } from 'ng-click-outside';
import { SidebarNavSecondaryItemComponent } from 'shared/components/sidebar-nav/sidebar-nav-secondary-item/sidebar-nav-secondary-item.component';

import { SidebarNavTertiaryItemComponent } from 'shared/components/sidebar-nav/sidebar-nav-tertiary-item/sidebar-nav-tertiary-item.component';
import { SidebarNavContainerComponent } from './sidebar-nav-container/sidebar-nav-container.component';
import { SidebarNavDrawerComponent } from './sidebar-nav-drawer/sidebar-nav-drawer.component';
import { SidebarNavItemComponent } from './sidebar-nav-item/sidebar-nav-item.component';
import { SidebarNavLogoComponent } from './sidebar-nav-logo/sidebar-nav-logo.component';
import { SidebarNavUserComponent } from './sidebar-nav-user/sidebar-nav-user.component';

@NgModule({
  imports: [ClickOutsideModule, CommonModule, RouterModule],
  declarations: [
    SidebarNavContainerComponent,
    SidebarNavLogoComponent,
    SidebarNavItemComponent,
    SidebarNavSecondaryItemComponent,
    SidebarNavTertiaryItemComponent,
    SidebarNavDrawerComponent,
    SidebarNavUserComponent,
  ],
  exports: [
    ClickOutsideModule,
    SidebarNavContainerComponent,
    SidebarNavLogoComponent,
    SidebarNavItemComponent,
    SidebarNavDrawerComponent,
    SidebarNavUserComponent,
  ],
})
export class SidebarNavModule {}
